import { Breadcrumb } from "antd";
import { FaChevronRight } from "react-icons/fa";

interface IProps {
  routes: Array<routesModel>;
}

interface routesModel {
  icon: JSX.Element;
  nombre: string;
}

export const BreadCrumb = (props: IProps) => {
  return (
    <div className="ps-2 padding-top-05 padding-bottom-05 container-breadcumb">
      <div className="container-fluid2">
      <div className=" overflow-auto">
        <Breadcrumb separator={<FaChevronRight size={7}></FaChevronRight>}>
          {props.routes.map((data: routesModel, index: number) => {
            if (index === props.routes.length - 1) {
              return (
                <Breadcrumb.Item key={data.nombre}>
                  <span className="font-size-9px font-color-000000 font-family-Montserrat-SemiBold text-nowrap">
                    {data.nombre}
                  </span>
                </Breadcrumb.Item>
              );
            }
            return (
              <Breadcrumb.Item key={data.nombre}>
                <span className="font-size-9px font-color-1BA0FF font-family-Montserrat-Regular text-nowrap">{data.nombre}</span>
              </Breadcrumb.Item>
            );
          })}
        </Breadcrumb>
      </div>
      </div>
    </div>
  );
};
